export default function PDFToolkitAIAccountDeletion() {
  return (
    <div className="min-h-screen bg-[#FBFAF6] text-[#26313B] p-8 md:p-16 transition-colors duration-300">
      <h1 className="text-4xl font-bold mb-6 text-[#26313B]">
        Account Deletion – PDF Toolkit AI
      </h1>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        At <strong>PDF Toolkit AI</strong>, we respect your privacy and believe
        you should have complete control over your data. You may request the
        permanent deletion of your account and all related data at any time by
        contacting our support team.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        📧 How to Request Deletion
      </h2>

      <p className="text-[#3D4B59] leading-relaxed mb-4">
        To request deletion of your account and all associated data, please
        email us at:
      </p>

      <p className="text-lg font-semibold text-[#0F6BBF] mb-4">
        📩{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="underline hover:text-[#0C599F]"
        >
          trionapps@gmail.com
        </a>
      </p>

      <p className="text-[#3D4B59] leading-relaxed mb-6 max-w-3xl">
        Please use the <strong>same email address</strong> associated with your
        PDF Toolkit AI account to verify your identity. Once your request is
        verified, we will permanently delete your account and all related data
        within <strong>7 business days</strong>.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">
        📂 What Data Will Be Deleted
      </h2>

      <ul className="list-disc list-inside text-[#3D4B59] leading-relaxed space-y-2 max-w-3xl">
        <li>
          Your user profile details (name, email, and profile photo) stored in
          Firebase Authentication.
        </li>
        <li>
          Your AI document chat logs, history, and file metadata stored in
          Firebase Firestore.
        </li>
        <li>Any usage or analytics data linked to your user account.</li>
      </ul>

      <p className="text-[#3D4B59] mt-4 max-w-3xl">
        Some aggregated or anonymized data may remain for performance analysis
        and legal compliance purposes, but it will never be personally
        identifiable.
      </p>

      <h2 className="text-2xl font-semibold mt-10 mb-4">🛡️ Need Help?</h2>

      <p className="text-[#3D4B59] leading-relaxed max-w-3xl">
        If you have any questions regarding data deletion, account management,
        or privacy concerns, feel free to reach us at{" "}
        <a
          href="mailto:trionapps@gmail.com"
          className="text-[#0F6BBF] underline hover:text-[#0C599F]"
        >
          trionapps@gmail.com
        </a>
        .
      </p>

      <p className="text-[#8A93A2] mt-10">
        Last updated: October 27, 2025
      </p>
    </div>
  );
}
